export default __webpack_public_path__ + "static/media/jayeH.1be6ce4a.png";